// extracted by mini-css-extract-plugin
export var border = "_1u-8";
export var brand = "_1u-t";
export var button = "_1u-l";
export var center = "_1u-a";
export var centered = "_1u-6";
export var closeButton = "_1u-c";
export var disabledWrapper = "_1u-m";
export var error = "_1u-p";
export var extraLarge = "_1u-4";
export var extraSmall = "_1u-1";
export var fill = "_1u-i";
export var footer = "_1u-h";
export var footerAction = "_1u-j";
export var footerButtons = "_1u-k";
export var header = "_1u-7";
export var headerWithClose = "_1u-d";
export var icon = "_1u-o";
export var info = "_1u-s";
export var inline = "_1u-9";
export var large = "_1u-3";
export var main = "_1u-e";
export var modal = "_1u-0";
export var nearFull = "_1u-5";
export var neutral = "_1u-u";
export var noPadding = "_1u-g";
export var none = "_1u-v";
export var scrollable = "_1u-f";
export var small = "_1u-2";
export var success = "_1u-r";
export var tight = "_1u-n";
export var titleIcon = "_1u-b";
export var warn = "_1u-q";